import { bindActionCreators } from '@reduxjs/toolkit';
import { createSelector } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { save } from '../../../../actions/credit-application';
import type { RootState } from '../../../../reducers';
import type { Persisted } from '../../../../reducers/credit-application';

const persistedSelector = createSelector(
  (state: RootState) => state.creditApplication.persisted,
  (persisted) => persisted,
);

type PersistedCallback = (
  ssn?: string | undefined,
  email?: string | undefined,
  estimatedMileage?: string | number | undefined,
  telephone?: string | undefined,
) => void;

const usePersistCreditApplicationState = (): [Persisted, PersistedCallback] => {
  const persisted = useSelector(persistedSelector);
  const dispatch = useDispatch();
  const persistData = bindActionCreators(save, dispatch);

  return [persisted, persistData];
};

export default usePersistCreditApplicationState;
